import {
  usePostCustomerStatisticsTotalQuery,
  usePostSegmentStatisticsTotalCustomersQuery,
} from "@tiny/api";
import { useRefreshRegister } from "@tiny/components/src/RefreshProvider";
import { formatNumber } from "@tiny/components/src/utils/formatUtils";

export function useTotalCustomerStatistics() {
  const { data, refetch, isLoading } = usePostCustomerStatisticsTotalQuery({});

  const {
    data: segmentData,
    refetch: refetchSegments,
    isLoading: isLoadingSegments,
  } = usePostSegmentStatisticsTotalCustomersQuery({ integrationLimit: 2 });

  useRefreshRegister(async () => {
    await refetch();
    await refetchSegments();
  });

  const manualUploadSegment = segmentData?.segments?.find(
    (segment) => segment.name === "Manual Upload"
  );

  const totalIntegrations = formatNumber(data?.fromIntegrations || 0);
  const totalManualUpload = formatNumber(
    manualUploadSegment?.numberOfCustomers || 0
  );
  const totalSubscribers = formatNumber(data?.numberOfUniqueCustomers || 0);

  return {
    totalSubscribers,
    totalIntegrations,
    totalManualUpload,
    isLoading: isLoading || isLoadingSegments,
  };
}
